import React, { useEffect, useState } from 'react';
import ZombiePurgeContent from '../ContentContainer';
import styles from './ZombiePurgeList.module.scss';
import ZombiePurgeListHeader from './Header';
import ZombiePurgeListCard from '../Card';
import { gsap } from 'gsap';
import { ethers } from 'ethers';

export default function ZombiePurgeList({ zombies, className, onListPurgeClick, otherAddress, setOtherAddress, isOtherAddressValid, setIsOtherAddressValid, isOtherAddressSimilarToConnectedAddress }) {
	const [selectedZombiesIds, setSelectedZombiesIds] = useState([]);
	const [isAllSelected, setIsAllSelected] = useState(false);
	const [mintToAnotherAddress, setMintToAnotherAddress] = useState(false);
	const [disablePurgeButton, setDisablePurgeButton] = useState(selectedZombiesIds?.length === 0);
	const emptyList = zombies?.length === 0;

	const validateAddress = (address) => {
		const isValid = ethers.isAddress(address);
		const disablePurging = !isValid;
		setDisablePurgeButton(disablePurging);
		setIsOtherAddressValid(isValid);
	};

	useEffect(() => {
		if (!mintToAnotherAddress) {
			setOtherAddress('');
		}
	}, [mintToAnotherAddress])

	useEffect(() => {
		setDisablePurgeButton(true);
	}, [isOtherAddressSimilarToConnectedAddress]);

	useEffect(() => {
		if (selectedZombiesIds.length > 0) {
			setDisablePurgeButton(false);
		}
		else {
			setDisablePurgeButton(true);
		}
	}, [selectedZombiesIds]);
	useEffect(() => {
		if (otherAddress !== '') {
			validateAddress(otherAddress);
		}
	}, [otherAddress]);

	const updateCardSelection = (zombieId) => {
		const wasSelected = selectedZombiesIds.includes(zombieId);
		if (wasSelected) {
			setSelectedZombiesIds((prev) => prev.filter((id) => id !== zombieId));
		}
		else {
			setSelectedZombiesIds((prev) => [...prev, zombieId]);
		}

	};

	const scrollToTop = () => {
		gsap.to(window, {
			duration: 1,
			scrollTo: { y: '#zombie-purge-header', offsetY: 100 },
		});
	};

	const onSelectAll = () => {
		const zombiesIds = [];
		if (!isAllSelected) {
			zombies.forEach((zombie) => {
				zombiesIds.push(zombie.id);
			});
		}
		setIsAllSelected((prev) => !prev);
		setSelectedZombiesIds(zombiesIds);
	};

	return (
		<ZombiePurgeContent className={className}>
			<ZombiePurgeListHeader selectedZombiesLength={selectedZombiesIds.length}
				emptyList={emptyList}
				zombiesLength={zombies?.length}
				onSelectAll={onSelectAll}
				isAllSelected={isAllSelected}
				disablePurgeButton={disablePurgeButton}
				onPurgeClick={() => onListPurgeClick(selectedZombiesIds)}
				setOtherAddress={(address) => setOtherAddress(address)}
				isValidAddress={isOtherAddressValid}
				otherAddress={otherAddress}
				setMintToAnotherAddress={setMintToAnotherAddress}
				mintToAnotherAddress={mintToAnotherAddress}
				isOtherAddressSimilarToConnectedAddress={isOtherAddressSimilarToConnectedAddress}
			/>

			<div id="zombie-purge-list"
				className={`border-box gap-y-10 flex justify-between items-center flex-wrap w-full h-auto max-[650px]:flex-col  max-[650px]:items-start ${styles['zombie-purge-list-content']}`}>
				{zombies.map((zombie) => {
					const isSelected = selectedZombiesIds.includes(zombie.id);
					return <ZombiePurgeListCard key={zombie.id}
						isSelected={isSelected}
						updateCardSelection={updateCardSelection}
						zombie={zombie} />;
				})}
			</div>

			{!emptyList && <button onClick={scrollToTop}
				className='m-0 mx-auto mt-8 block'>
				Back to top
			</button>}
		</ZombiePurgeContent>
	);
}
